const STATUS_COLORS = {
  PENDING: 'blue',
  APPROVED: 'green',
  REJECTED: 'red',
  EXPIRED: 'grey',
  COMPLETED: 'green'
}

export function getStatusColor(status) {
  return STATUS_COLORS[status] || 'blue'
}

export function formatRequestDate(dateStr) {
  if (!dateStr) return '-'
  try {
    const date = new Date(dateStr)
    return date.toLocaleDateString('es-MX')
  } catch (e) {
    return dateStr
  }
}

function diffDaysFromToday(deadline) {
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  const deadlineDate = new Date(deadline)
  deadlineDate.setHours(0, 0, 0, 0)
  return Math.ceil((deadlineDate - today) / (1000 * 60 * 60 * 24))
}

export function daysRemainingLabel(deadline) {
  if (!deadline) return 'Sin límite'
  const diffDays = diffDaysFromToday(deadline)
  if (diffDays <= 0) return 'Vencido'
  if (diffDays === 1) return '1 día restante'
  return `${diffDays} días restantes`
}

export function daysRemainingColor(deadline) {
  if (!deadline) return 'grey'
  const diffDays = diffDaysFromToday(deadline)
  return diffDays <= 3 ? 'red' : 'grey'
}
